export default __webpack_public_path__ + "static/media/vjcet-building.3ae03777.jpeg";